import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';

import { digitCounts } from '../../static/fixedDigits';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faNewspaper,
  faCircle,
  faCheck
} from '@fortawesome/free-solid-svg-icons';

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const ColumnValue = styled.div`
  flex: ${props => props.flex ? props.flex : 1};
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.align};
  align-items: center;
  /* font-size: .65em; */
  padding-left: ${props => props.$controls ? '1px' : props.align === 'left' ? '4px' : '0'};
  min-width: ${props => props.$minWidth ? props.$minWidth : props.$controls ? '1.5em' : '5em'};
  ${props => props.$controls ? 'max-width: 1.5em;' : null}
  min-height: 2em;
  position: ${props => (props.$valueIndex === 0 || props.$controls) ? '-webkit-sticky' : 'static'};
  position: ${props => (props.$valueIndex === 0 || props.$controls) ? 'sticky' : 'static'};
  left: ${props => props.$controls ? '0' : props.$valueIndex === 0 ? 'calc(1.5em + 1px)' : 'auto'};
  border-right: ${props => props.$controls ? 'none' : '1px dashed #999'};
  background-color: ${props => props.$hovered ? 'rgb(213, 233, 247)' : props.$rowIndex % 2 > 0 ? '#ccc' : 'white'};
  // ${props => (props.$valueIndex === 0 || props.$controls) && 'background: white;'}
  color: black;

  > a {
    color: black;
  }

  > a:hover {
    color: #228fd8;
  }
`;

const AgentsPlayed = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  padding: 0 .3em;
`

const Consistency = styled.div`
  font-size: .75em;
`

const AgentImage = styled.img`
  max-height: 1.5em;
`

const ControlsBlock = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: .1em .25em;

  & a {
    color: inherit;
  }

  & a:hover {
    color: #228fd8;
  }

  > svg:hover {
    color: #228fd8 !important;
  }
`;

const calcMinWidth = (valueIndex, columnLabel, statsType) => {
  if (valueIndex === 0 && statsType === 'teams') {
    return '12em';
  } else if (valueIndex === 0) {
    return '9em';
  } else {
    return '5em';
  }
}

const ConsistencyLabels = {
  1: 'Very low',
  2: 'Low',
  3: 'Medium',
  4: 'High',
  5: 'Very high'
}

const StatsRow = (props) => {
  const [hovered, setHovered] = useState(false);

  const updateProcessing = props.AppStore.playerStatusIsUpdating.get() === props.rowData.playerId;

  const agentsPlayed = props.rowData.Agents ? JSON.parse(props.rowData['Agents']) : null;

  const profileLink = ['topPlayers', 'players'].includes(props.statsType)
    ? `/player/${props.rowData.playerId}`
    : props.statsType === 'teams'
      ? `/team/${props.rowData.teamId}`
      : null
    ;

  useEffect(() => {
    // wat do
  }, [
    props.AppStore,
    props.rowData,
    updateProcessing
  ]);

  return (
    <RowContainer
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <ColumnValue
        key='controls'
        label='controls'
        $controls={true}
        align='left'
        $rowIndex={props.rowIndex}
        $valueIndex='0'
        $hovered={hovered}
      >
        <ControlsBlock>
          {['topPlayers', 'players'].includes(props.statsType) ? (
            <Link to={profileLink}>
              <FontAwesomeIcon
                icon={faNewspaper}
                title='View profile page'
              />
            </Link>
          ) : (
            <FontAwesomeIcon
              icon={faNewspaper}
              title='Team profile pages not yet available'
            />
          )}
        </ControlsBlock>
      </ColumnValue>
      {props.AppStore.statsColumns.map((column, valueIndex) => {
        var columnValue = null;
        const columnIsPopulated = props.rowData[column] != null;
        if (!columnIsPopulated) {
          columnValue = '-';
        } else if (
          typeof props.rowData[column] === 'number' &&
          column in digitCounts
        ) {
          columnValue = props.rowData[column].toFixed(digitCounts[column]);
        } else {
          columnValue = props.rowData[column];
        }

        return (
          <ColumnValue
            key={column}
            label={column}
            align={
              valueIndex === 0
                ? 'left'
                : 'center'
            }
            $minWidth={calcMinWidth(valueIndex, column, props.statsType)}
            $rowIndex={props.rowIndex}
            $valueIndex={valueIndex}
            $hovered={hovered}
          >
            {valueIndex === 0 ? (
              ['topPlayers', 'players'].includes(props.statsType)
                ? <Link to={profileLink}>{columnValue}</Link>
                : columnValue
            ) : column === 'Agents' ? (
              <AgentsPlayed>
                {agentsPlayed ? (
                  agentsPlayed.map((agent, idx) => {
                    if (idx > 2) {
                      return null;
                    }
                    return (
                      <AgentImage
                        key={`${props.rowData.playerId}-${agent.agentId}`}
                        src={`https://media.valorant-api.com/agents/${agent.agentId}/displayicon.png`}
                      />
                    )
                  })
                ) : (
                  '-'
                )}
              </AgentsPlayed>
            ) : column === 'IGL' ? (
              columnValue === 'Yes' ? (
                <FontAwesomeIcon
                  icon={faCheck}
                  style={{ 'fontSize': '1.2em' }}
                />
              ) : (
                '-'
              )
            ) : column === 'CNS' ? (
              columnValue !== '-' ? (
                <Consistency
                  title={`${ConsistencyLabels[columnValue]} consistency`}
                >
                  {
                    [...Array(columnValue)].map((_, idx) => {
                      return (
                        <FontAwesomeIcon
                          key={`${props.rowData.playerId}-consistency-circle-${idx}`}
                          icon={faCircle}
                        />
                      )
                    })
                  }
                </Consistency>
              ) : (
                columnValue
              )
            ) : (
              columnValue
            )}
          </ColumnValue>
        );
      })}
    </RowContainer>
  );
};

export default inject('AppStore')(observer(StatsRow))